var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgenciaCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39999 18H40.4V38C40.4 38.5304 40.1893 39.0391 39.8142 39.4142C39.4391 39.7893 38.9304 40 38.4 40H10.4C9.86956 40 9.36085 39.7893 8.98578 39.4142C8.61071 39.0391 8.39999 38.5304 8.39999 38V18Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 27H29.9C30.4304 27 30.9391 27.2107 31.3142 27.5858C31.6893 27.9609 31.9 28.4696 31.9 29V40H16.9V29C16.9 28.4696 17.1107 27.9609 17.4858 27.5858C17.8609 27.2107 18.3696 27 18.9 27Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 8L15.4 13.5L10.36 8.46C10.7194 8.16459 11.1697 8.00213 11.635 8H20.9Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 13.5L6.89999 22H6.63499C6.29424 21.9993 5.9593 21.9117 5.66182 21.7455C5.36435 21.5793 5.11419 21.34 4.93499 21.0502C4.75579 20.7604 4.65348 20.4296 4.63773 20.0893C4.62198 19.7489 4.69332 19.4101 4.84499 19.105L9.84499 9.10496C9.97061 8.85692 10.1459 8.63737 10.36 8.45996L15.4 13.5Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 22H6.89999L15.4 13.5L23.9 22Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 34.5H19.9C19.6348 34.5 19.3804 34.3946 19.1929 34.2071C19.0053 34.0196 18.9 33.7652 18.9 33.5C18.9 33.2348 19.0053 32.9804 19.1929 32.7929C19.3804 32.6054 19.6348 32.5 19.9 32.5H28.9C29.1652 32.5 29.4196 32.6054 29.6071 32.7929C29.7946 32.9804 29.9 33.2348 29.9 33.5C29.9 33.7652 29.7946 34.0196 29.6071 34.2071C29.4196 34.3946 29.1652 34.5 28.9 34.5Z",
    fill: "#0083CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.955 19.105L38.955 9.105C38.7878 8.77345 38.5321 8.49469 38.2161 8.29964C37.9001 8.10459 37.5363 8.00088 37.165 8H20.9L15.4 13.5L23.9 22H42.165C42.5059 21.9998 42.8412 21.9126 43.1389 21.7465C43.4366 21.5804 43.687 21.341 43.8663 21.0511C44.0456 20.7611 44.1479 20.4301 44.1634 20.0895C44.1789 19.749 44.1072 19.4101 43.955 19.105Z",
    fill: "#FFD400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenciaCor);
export default __webpack_public_path__ + "static/media/agencia-cor.92cb5861cb05fe327aa86b502ebab48f.svg";
export { ForwardRef as ReactComponent };